import { ApiFragment, Identifier } from '@stylehaven/components';

export function recordHasId(record: ApiFragment, id: Identifier): boolean {
    return record.getFragmentId() === id || record.getMediaObjectId() === id || record.getRecordId() === id;
}
